import styled from 'styled-components';
import { Colors } from '../common/design-system';

interface HamburgerProps {
  isOpen: boolean;
  onClick: () => void;
}

const StyledHamburger = styled.button<{ isOpen: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 2rem;
  height: 1rem;
  background: transparent;
  border: none;
  cursor: pointer;
  z-index: 1000;

  &:focus {
    outline: none;
  }

  div {
    width: 1.5rem;
    height: 0.15rem;
    background: ${Colors.black};
    border-radius: 10px;
    transition: all 0.2s ease-in-out;
    position: relative;
    transform-origin: 1px;

    &:first-child {
      transform: ${({ isOpen }) => isOpen ? 'rotate(45deg) translateX(-3px)' : 'rotate(0)'};
    }

    &:nth-child(2) {
      opacity: ${({ isOpen }) => isOpen ? '0' : '1'};
      transform: ${({ isOpen }) => isOpen ? 'translateX(20px)' : 'translateX(0)'};
    }

    &:nth-child(3) {
      transform: ${({ isOpen }) => isOpen ? 'rotate(-45deg) translateX(-2px)' : 'rotate(0)'};
    }
  }
`;

const HamburgerIcon = ({ isOpen, onClick }: HamburgerProps) => {
  return (
    <StyledHamburger isOpen={isOpen} onClick={onClick}>
      <div />
      <div />
      <div />
    </StyledHamburger>
  );
};

export default HamburgerIcon; 